// src/components/BackButton.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../assets/styles/BackButton.module.scss';

interface BackButtonProps {
    to?: string;
    onClick?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ to = '/', onClick }) => {
    if (onClick) {
        return (
            <div className={styles.backWrapper}>
                <button className={styles.backButton} onClick={onClick}>
                    ← Back
                </button>
            </div>
        );
    }

    return (
        <div className={styles.backWrapper}>
            <Link to={to} className={styles.backButton}>← Back</Link>
        </div>
    );
};

export default BackButton;
